import { Text, Box, Flex, Button, Heading } from "@chakra-ui/react";
import { useRouter } from "next/router";
import { useUser } from "../../hooks/use-user";
import ConfettiExplosion from "react-confetti-explosion";
import { useContext, useEffect, useState } from "react";
import { minHeight, quizColors } from "../../hooks/use-guide";
import { LocalizationContext } from "../../hooks/use-localization";

interface Props {
  onReset: () => void;
}

export default function ViewCompletion(props: Props) {
  const { l } = useContext(LocalizationContext);
  const user = useUser();
  const router = useRouter();
  const [showConfetti, setShowConfetti] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShowConfetti(true);
    }, 1000);
  }, []);
  return (
    <>
      <Box
        backgroundColor={quizColors.primary}
        w={"100%"}
        h="100%"
        position={"absolute"}
        left={0}
        top={0}
      ></Box>

      <Flex
        zIndex={1}
        color="white"
        justifyContent={"center"}
        alignItems="center"
        flexDir={"column"}
        h={minHeight}
      >
        {showConfetti && (
          <ConfettiExplosion
            force={0.5}
            duration={1000}
            onComplete={() => setShowConfetti(false)}
          />
        )}
        <Heading fontSize="5xl" lineHeight={"lg"}>
          {l ? l["guide.completion.title"] : "Well done!"}
        </Heading>

        <Text fontSize="md">{l ? l["guide.completion.subtitle"] : "You completed the guide"}</Text>

        {user.sessionUser ? (
          <Button
            id="completion-dashboard-button"
            mt={10}
            variant="outline"
            color={"white"}
            _hover={{ borderColor: "black", color: "black" }}
            background={"transparent"}
            onClick={() => router.push("/app")}
          >
            {l ? l["guide.completion.goToDashboard"] : "Go to Dashboard"}
          </Button>
        ) : (
          <Flex mt={10} flexDir="column" textAlign={"center"}>
            <Text fontWeight={"bold"}>Continue your language journey with Talkio AI</Text>
            <Text fontWeight={"bold"}>Fluent in a flash for only $9 a month!</Text>

            <Button
              id="completion-signup-button"
              colorScheme={"brand.primary"}
              color={"black"}
              onClick={() => router.push("/authentication/signup")}
              mt={10}
            >
              Sign up - 7 days free
            </Button>
          </Flex>
        )}

        <Text
          cursor={"pointer"}
          _hover={{ color: "black" }}
          textDecor={"underline"}
          fontSize="sm"
          mt={2}
          as="a"
          onClick={props.onReset}
        >
          {l ? l["guide.completion.tryAgain"] : "Try again"}
        </Text>
      </Flex>
    </>
  );
}
